import React from 'react'
import { Typewriter } from 'react-simple-typewriter'

export default function TypeWord() {
    return (
        <div>
            <h1 style={{ margin: 'auto 0', fontWeight: '600' }}>
                Instant Personal Loans for Salaried Professionals{' '} <br/>
                <span style={{ color: '#FF7B0E' }}>
                    <Typewriter words={['Instant Approval', 'Paperless Process', 'Apply from Anywhere']}
                        loop={true}
                        cursor
                        cursorStyle='_'
                        typeSpeed={70}
                        deleteSpeed={50}
                       
                        delaySpeed={1000} />
                </span>
            </h1>

          
        </div>
    )
}
